import React from 'react'
import { Plus } from 'react-feather'

export const Button = ({ text, onClick, type }) => {
  return (
    <button onClick={onClick} type={type} className="Card_Link">
      <Plus size={22} />
      <span>{text}</span>
    </button>
  )
}

export default Button
